import React from "react";
import { Outlet, useNavigate, useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";

import AccessBlocked from "../../../routes/AccessBlocked";

const OSS_ACCESS_STORAGE_KEY = "legup_oss_access_context";

export function OssAccessCodeGuard() {
  const navigate = useNavigate();
  const { t } = useTranslation("guard");

  // Receive the registration state from OssRegistrationLayout.
  const parentContext = useOutletContext();

  let accessContext = {};

  try {
    accessContext = JSON.parse(
      localStorage.getItem(OSS_ACCESS_STORAGE_KEY) || "{}",
    );
  } catch {
    accessContext = {};
  }

  const hasVerifiedAccessCode = Boolean(
    accessContext?.email &&
    accessContext?.access_code &&
    accessContext?.preview?.ok,
  );

  if (!hasVerifiedAccessCode) {
    return (
      <AccessBlocked
        title={t("guards.accessCodeRequiredTitle")}
        description={t("guards.accessCodeRequiredDescription")}
        primaryActionLabel={t("guards.enterAccessCode")}
        primaryActionPath="/register/oss/access-code"
        secondaryActionLabel={t("common.goBack")}
        onSecondaryAction={() => navigate("/register/oss/access-code")}
      />
    );
  }

  return <Outlet context={parentContext} />;
}
